import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

/**
 * true quando la colonna `table.column` esiste nel database.
 *
 * Serve a mostrare e salvare un campo nuovo solo dopo che la sua migration è
 * stata applicata: prima il form resta com'era e non invia la chiave (un
 * insert/update con una colonna inesistente fallirebbe con 42703). Il risultato
 * è tenuto in cache per sessione.
 */
const cache = new Map<string, Promise<boolean>>();

export function checkDbColumnSupported(table: string, column: string): Promise<boolean> {
  const key = `${table}.${column}`;
  let pending = cache.get(key);
  if (!pending) {
    pending = Promise.resolve(
      supabase.from(table).select(column).limit(1).then(({ error }) => !error)
    ).catch(() => false);
    // Un errore di rete non deve restare in cache come "colonna assente"
    pending.then((ok) => { if (!ok) cache.delete(key); });
    cache.set(key, pending);
  }
  return pending;
}

export function useDbColumnSupported(table: string, column: string): boolean {
  const [supported, setSupported] = useState(false);
  useEffect(() => {
    let cancelled = false;
    checkDbColumnSupported(table, column).then((ok) => { if (!cancelled) setSupported(ok); });
    return () => { cancelled = true; };
  }, [table, column]);
  return supported;
}
